export default theme => ({
  tooltipContainer: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    width: '100%'
  },
  tooltipContent: {
    cursor: 'default',
    width: '95%'
  },
  copyIcon: {
    width: '1rem',
    height: '1rem',
    marginLeft: 6,
    marginBottom: -2,
    cursor: 'pointer',
    color: theme.palette.text.icon
  },
  iconsContainer: {
    display: 'flex',
    visibility: 'hidden'
  },
  showOnHover: {
    visibility: 'visible'
  },
  linkContainer: {
    display: 'flex',
    cursor: 'pointer',
    width: theme.spacing(3),
    height: theme.spacing(3),
    marginTop: 2,
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  shortenPath: {
    display: 'block',
    width: '100%'
  }
});
